import React from 'react';
import { PapiDeviation, RelatedBlock } from '@wix/da-papi-types';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import UserBlock from './UserBlock';
import s from './Users.scss';

interface Props {
  block: RelatedBlock;
  deviation: PapiDeviation;
}

const Users: React.FC<React.PropsWithChildren<Props>> = ({ block, deviation: parentDeviation }) => {
  const shouldLinkToGallery = block.layout === 0 && block.contentTitleType === 'more-by';
  const linkTo = shouldLinkToGallery ? 'gallery' : undefined;
  return (
    <SidebarBlockWrapper deviation={parentDeviation} block={block} headerClassName={s['header']}>
      <div>
        {block.users?.map(
          ({ user, deviations }) =>
            user &&
            deviations && (
              <UserBlock
                key={user.userId}
                parentDeviation={parentDeviation}
                user={user}
                deviations={deviations}
                linkTo={linkTo}
              />
            )
        )}
      </div>
    </SidebarBlockWrapper>
  );
};
Users.displayName = 'Users';

export default Users;
